import type { MessageTranslator } from '@oneflowab/pomes';

import EmptyState from '@app/components/empty-state/empty-state';
import DocumentSearch from '@app/components/icons/document-search';

type Props = {
  message: MessageTranslator;
};

export const EmptySearchResultState = ({ message }: Props) => (
  <EmptyState
    newStyle
    icon={
      <DocumentSearch
        height="250px"
        width="250px"
      />
    }
    header={message({
      id: 'No documents match your search',
      comment: 'Empty state header. Shown in document list when no documents are found.',
    })}
    content={message({
      id: 'Try searching by document title, ID, participant name, tag, or by adjusting your filters.',
      comment: 'Empty state content. Shown in document list when no documents are found.',
    })}
  />
);
